import { QueryKey } from "@tanstack/react-query";

export const productAsMemberQueryKeys = {
  all: () => ["product-as-member"] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) =>
    [...productAsMemberQueryKeys.all(), { filters }] as QueryKey,
  summary: (params?: Readonly<{ [k: string]: any }>) =>
    [...productAsMemberQueryKeys.all(), "summary", params] as QueryKey,
  details: (productId?: number) =>
    [...productAsMemberQueryKeys.all(), productId] as QueryKey,
  categorySearch: (filters: Readonly<{ [k: string]: any }>) =>
    ["product-category-search", { filters }] as QueryKey,
};
